import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { PAGINATOR } from '../table-pagination.constants';

@Injectable()
export class PaginatorIntlUtil implements MatPaginatorIntl {
  changes = new Subject<void>();
  firstPageLabel = $localize`First page`;
  itemsPerPageLabel = $localize`Items per page:`;
  lastPageLabel = $localize`Last page`;
  nextPageLabel = $localize`Next page`;
  previousPageLabel = $localize`Previous page`;

  getRangeLabel(page: number, pageSize: number, length: number) {
    const nextPageVal = (page + 1) * pageSize;
    const nextPage = nextPageVal > length ? length : nextPageVal;
    const text = PAGINATOR.replace('%a', (page * pageSize + 1).toString())
      .replace('%b', nextPage.toString())
      .replace('%c', length.toString());
    return text;
  }
}
